import { render, staticRenderFns } from "./page-check.vue?vue&type=template&id=3e60b5ea&"
import script from "./page-check.vue?vue&type=script&lang=js&"
export * from "./page-check.vue?vue&type=script&lang=js&"
import style0 from "./page-check.vue?vue&type=style&index=0&id=3e60b5ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports